export const desktopMinWidth = { minWidth: 1200 };
